import React from 'react'
import ShowMarkdown from '../../../components/atoms/ShowMarkdown'
import RouterMetaTags from '../../../components/molecules/RouterMetaTags'
import { Routes } from '../../../consts'

const Component = () => (
  <>
    <RouterMetaTags route={Routes.Help} />
    <ShowMarkdown target="Help" />
  </>
)

export default Component
